import { combineReducers } from '@reduxjs/toolkit';
import clientFilterReducer from './features/clientList/clientListFilterSlice';
import employeeListFilterReducer from './features/employeeList/employeeListFilterSlice';
import reviewActivitySheetFilterReducer from './features/reviewActivitySheet/reviewActivitySheetFilterSlice';
import ifspClientDetailsReducer from './features/ifsp/ifspClientDetailsSlice';
import ifspDailyRoutineReducer from './features/ifsp/ifspDailyRoutineSlice';
import ifspFamilyConcernReducer from './features/ifsp/ifspFamilyConcernSlice';
import ifspHealthSummaryReducer from './features/ifsp/ifspHealthSummarySlice';
import ifspDevelopmentSummaryReducer from './features/ifsp/ifspDevelopmentSummarySlice';
import ifspOutcomesReducer from './features/ifsp/ifspOutcomesSlice';
import ifspSDPAndConsent from './features/ifsp/ifspSDPAndConsentSlice';
import ifspTransitionDetails from './features/ifsp/ifspTransitionSlice';
import ifspHeatBeatDetails from './features/ifsp/ifspHeartBeatslice';
import ifspFormValidationsDetails from './features/ifsp/ifspFormValidationsSlice';
import ifspPermissionDetails from './features/ifsp/ifspPermissionSlice';
import ifspTBRPreRequisite from './features/ifsp/ifspTBRPreRequisiteSlice';
import ifspUnsavedField from './features/ifsp/ifspUnsavedFieldSlice';

const rootReducer = combineReducers({
  clientFilter: clientFilterReducer,
  reviewActivitySheetFilter: reviewActivitySheetFilterReducer,
  employeeListFilter: employeeListFilterReducer,
  ifspClientDetails: ifspClientDetailsReducer,
  ifspDailyRoutineReportDetails: ifspDailyRoutineReducer,
  ifspFamilyConcernReportDetails: ifspFamilyConcernReducer,
  ifspHealthSummaryReportDetails: ifspHealthSummaryReducer,
  ifspDevelopmentSummaryReportDetails: ifspDevelopmentSummaryReducer,
  ifspOutComes: ifspOutcomesReducer,
  ifspSDPAndConsent: ifspSDPAndConsent,
  ifspTransitionDetails: ifspTransitionDetails,
  ifspHeatBeatDetails: ifspHeatBeatDetails,
  ifspFormValidationsDetails: ifspFormValidationsDetails,
  ifspPermissionDetails: ifspPermissionDetails,
  ifspTBRPreRequisite: ifspTBRPreRequisite,
  ifspUnsavedFields: ifspUnsavedField,
});

export type RootReducerType = ReturnType<typeof rootReducer>;

export default rootReducer;
